<div class="quarterly-feedback-main-container">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToVendorManagement()">
      {{routesEnum.feedbackForm}}
    </span>
  </div>

  <div class="quarterly-feedback-form">
    <h2 class="quarterly-feedback-heading">
      {{ quarterlyFeedback.feedbackHeading }}
    </h2>
    <form [formGroup]="quarterlyFeedbackForm" *ngIf="!isLoading" class="feedback-form">
      <!-- People Metrics Section -->
      <div class="section-container">
        <div class="section-title">{{ quarterlyFeedback.peopleMetrics }}</div>
        <div class="section-form">
          <ng-container *ngFor="let field of peopleMetricsFields">
            <emerald-input
              [label]="field.label"
              [outlined]="true"
              [formControlName]="field.control"
              [isValid]="isFieldValid(field.control)"
              [errorText]="getFieldError(field.control)"
              [disabled]="field.disabled">
            </emerald-input>
          </ng-container>
        </div>
      </div>

      <!-- Supporting Documents Section -->
      <div class="section-container">
        <div class="section-form">
          <div class="full-width-container">
            <div class="file-upload-container full-width">
              <app-file-upload #supportingDocsUpload formControlName="supportingDocs"
                [error]="fileErrors['supportingDocs']" [selectedFile]="selectedFiles['supportingDocs']"
                [isSubmitted]="isSubmitted" (fileSelected)="onFileSelected($event, 'supportingDocs')"
                (fileRemoved)="onFileRemoved('supportingDocs')"></app-file-upload>
            </div>
          </div>
        </div>
      </div>

      <div class="section-divider"></div>

      <!-- Strategic Partnership Section -->
      <div class="section-container">
        <div class="section-title">{{ quarterlyFeedback.strategicPartnership }}</div>
        <div class="section-form">
          <emerald-input [label]="quarterlyFeedback.investmentPrograms" [outlined]="true" formControlName="sowCompliance"
            [isValid]="isFieldValid('sowCompliance')" [errorText]="getFieldError('sowCompliance')">
          </emerald-input>
          <emerald-input [label]="quarterlyFeedback.coinnovatedIdeas" [outlined]="true"
            formControlName="invoiceCompliance" [isValid]="isFieldValid('invoiceCompliance')"
            [errorText]="getFieldError('invoiceCompliance')">
          </emerald-input>
        </div>
      </div>

      <!-- Strategic Partnership Upload Section -->
      <div class="section-container">
        <div class="section-form">
          <div class="file-upload-container">
            <app-file-upload #sowUploadFileUpload formControlName="sowUpload" [error]="fileErrors['sowUpload']"
              [selectedFile]="selectedFiles['sowUpload']" [isSubmitted]="isSubmitted"
              (fileSelected)="onFileSelected($event, 'sowUpload')"
              (fileRemoved)="onFileRemoved('sowUpload')"></app-file-upload>
          </div>

          <div class="file-upload-container">
            <app-file-upload #invoiceUploadFileUpload formControlName="invoiceUpload"
              [error]="fileErrors['invoiceUpload']" [selectedFile]="selectedFiles['invoiceUpload']"
              [isSubmitted]="isSubmitted" (fileSelected)="onFileSelected($event, 'invoiceUpload')"
              (fileRemoved)="onFileRemoved('invoiceUpload')"></app-file-upload>
          </div>
        </div>
      </div>

      <!-- Learning & Development Section -->
      <div class="section-container">
        <div class="section-title">{{ quarterlyFeedback.learningDevelopment }}</div>
        <div class="section-form">
          <div class="file-upload-container full-width">
            <app-file-upload #learningDocsUpload formControlName="learningDocs" [error]="fileErrors['learningDocs']"
              [selectedFile]="selectedFiles['learningDocs']" [isSubmitted]="isSubmitted"
              (fileSelected)="onFileSelected($event, 'learningDocs')"
              (fileRemoved)="onFileRemoved('learningDocs')"></app-file-upload>
          </div>
        </div>
        <div class="section-title">
          <a
            [href]="excelFilePath"
            download="learning-development-template.xlsx"
            class="download-link"
         >
            {{ quarterlyFeedback.learningDevelopmentFormatMessage }}
        </a>
  </div>
      </div>

      <!-- Button Section -->
      <div class="button-container">
        <emerald-button [type]="'Secondary'" (onClick)="onCancel()">Cancel</emerald-button>
        <emerald-button [type]="'Primary'" (onClick)="onSave()">Save</emerald-button>
      </div>
    </form>
  </div>
</div>
